<app-nav></app-nav>
<main class="landing-main">
    <section>
        <app-privacy-policy-content/>
    </section>
    <div class="btn-cont">
        <a routerLink="/" class="button-primary">
            Volver Atrás
        </a>
    </div>
</main>
<app-footer />
